import React from "react"
import ReactPlayer from 'react-player'


export const BlogpostExternerInhalt = ({data}) => {
    return <div className="externer-inhalt-container">
        <ReactPlayer className="externer-inhalt" controls={true} url={data.URL}/>
    </div>
    }